
function Footer(){
    return(
        <footer className="footer">
        <span className="footer-title">Developed by Grauleau Matthieu ©2023 – All Rights Reserved</span>
      </footer>
    )
}

export default Footer